/**
 * Purview CVC Page
 * Main page component that renders the Purview CVC (Customer Value Conversation) dashboard
 */

import React from "react";
import { PurviewCVCContainer } from "../components/PurviewCVC/PurviewCVCContainer";

const PurviewCVCPage: React.FC = () => {
    return (
        <div style={{ minHeight: "100vh" }}>
            <PurviewCVCContainer />
        </div>
    );
};

export default PurviewCVCPage;
